(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-component-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-item-filter')) {
    customElements.define(
      'accordion-item-filter',
      class AccordionItemFilter extends HTMLElement {
        constructor() {
          super();
          this.heading = this.querySelector('.accordion-container__heading-area');
          this.content = this.querySelector('.accordion-container__content');
          this.type = this.dataset.type || 'normal';

          this.heading.addEventListener('click', this.singleToggleAccordion.bind(this));

          if (this.type == 'sort_by') {
            this.addEventListener('input', (e) => {
              console.log(e.target.dataset.name);
              document.querySelector('#sort_title').innerText = e.target.dataset.name;
            });
          }
        }

        singleToggleAccordion() {
          this.querySelector('.accordion-container__content').style.height = '0px';
          const isOpen = this.classList.contains('open');

          if (isOpen) {
            this.closeAccordion();
          } else {
            this.openAccordion();
          }
        }

        toggleAccordion() {
          this.closest('filter-drawer')
            .querySelectorAll('accordion-item-filter')
            .forEach((item) => {
              if (item !== this) {
                item.classList.remove('open');
                item.querySelector('.accordion-container__content').style.height = '0px';
              }
            });

          const isOpen = this.classList.contains('open');

          if (isOpen) {
            this.closeAccordion();
          } else {
            this.openAccordion();
          }
        }

        openAccordion() {
          this.classList.add('open');
          const contentHeight = this.content.scrollHeight;
          this.content.style.height = `${contentHeight + 3}px`;
        }

        closeAccordion() {
          this.classList.remove('open');
          this.content.style.height = '0px';
        }

        connectedCallback() {
          // Initial collapse
          this.content.style.height = '0px';
          this.content.style.opacity = '1';

          const filterDrawer = this.closest('filter-drawer');
          if (!filterDrawer) return;

          // Ensure _accordions exists
          if (!filterDrawer._accordions) {
            filterDrawer._accordions = [];
            this.setupFilterDrawerListeners(filterDrawer);
          }

          // Avoid duplicate pushes
          if (!filterDrawer._accordions.includes(this)) {
            filterDrawer._accordions.push(this);
          }

          // Only open first accordion if this is the *first time*
          if (filterDrawer._accordions.length === 1) {
            this.openAccordion();
          } else {
            this.closeAccordion();
          }
        }

        disconnectedCallback() {
          // Clean up reference when element is removed
          const filterDrawer = this.closest('filter-drawer');
          if (filterDrawer && filterDrawer._accordions) {
            const index = filterDrawer._accordions.indexOf(this);
            if (index > -1) {
              filterDrawer._accordions.splice(index, 1);
            }
          }
        }

        setupFilterDrawerListeners(filterDrawer) {
          // Listen for filter close event
          filterDrawer.addEventListener('filterClose', (e) => {
            // Close all accordions within this filter drawer
            const accordions = filterDrawer.querySelectorAll('accordion-item-filter');
            setTimeout(() => {
              accordions.forEach((accordion) => {
                accordion.closeAccordion();
              });

              // Open the first accordion if it exists
              if (accordions.length > 0) {
                accordions[0].openAccordion();
              }
            }, 700);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atc-nd-enquiry"] && !Shopify.designMode) return;
  try {
    document.querySelector('#make-enquiry-button').addEventListener('click', () => {
    if (window.innerWidth < 1200) {
      document.querySelector('custom-header').classList.remove('custom-header--hidden');
      document.querySelector('#inquiry__form-button-mobile--open').click();
      setTimeout(() => {
        if (!document.querySelector('#mobile-contact-back').classList.contains('hidden')) {
          document.querySelector('#mobile-contact-back').classList.add('hidden');
        }
        document.querySelector('#mobile-menu__drawer-btn--open').click();
        document.querySelector('custom-header').style.opacity = 1;

        document.querySelector('#mobile-contact-trigger').click();
      }, 200);
    } else {
      document.querySelectorAll('.contact-drawer-trigger').forEach((trigger) => {
        trigger.click();
        document.querySelectorAll('#inquiry-form-panel').forEach((form) => {
          form.classList.remove('hidden');
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-sticky-button"] && !Shopify.designMode) return;
  try {
    document.querySelector('#make-enquiry-button--sticky').addEventListener('click', () => {
    if (window.innerWidth < 1200) {
      document.querySelector('custom-header').classList.remove('custom-header--hidden');
      setTimeout(() => {
        document.querySelector('#mobile-menu__drawer-btn--open').click();
        document.querySelector('#mobile-contact-trigger').click();
      }, 200);
    } else {
      document.querySelectorAll('.contact-drawer-trigger').forEach((trigger) => {
        trigger.click();
        document.querySelectorAll('#inquiry-form-panel').forEach((form) => {
          form.classList.remove('hidden');
        });
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const stickyAtc = document.getElementById('sticky-atc');
    const mainButtonContainer = document.querySelector('#atc-enquiry-buttons');

    if (!stickyAtc) {
      console.error('Sticky ATC element not found');
      return;
    }

    // Track visibility state of different sections
    let isMainButtonVisible = false;
    let isCollectionVisible = false;
    let isFooterVisible = false;

    function updateStickyVisibility() {
      const isMobile = window.innerWidth <= 1024;

      // On desktop, hide only when main button is visible
      if (!isMobile) {
        if (isMainButtonVisible) {
          hideStickyBar();
        } else {
          showStickyBar();
        }
        return;
      }

      // On mobile, hide if ANY of the sections are visible
      if (isMainButtonVisible || isCollectionVisible || isFooterVisible) {
        hideStickyBar();
      } else {
        showStickyBar();
      }
    }

    function hideStickyBar() {
      stickyAtc.classList.remove('sticky-atc--visible');
      stickyAtc.classList.add('sticky-atc--hidden');
    }

    function showStickyBar() {
      stickyAtc.classList.remove('sticky-atc--hidden');
      stickyAtc.classList.add('sticky-atc--visible');
    }

    // Observer for main button container
    if (mainButtonContainer) {
      const mainButtonObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isMainButtonVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      mainButtonObserver.observe(mainButtonContainer);
    }

    // Observer for animated collection section (mobile only)
    const animatedCollection = document.querySelector('[data-section-type="animated-collection"]');
    if (animatedCollection) {
      const collectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isCollectionVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      collectionObserver.observe(animatedCollection);
    }

    // Observer for footer (mobile only)
    const footer = document.querySelector('.global-footer');
    if (footer) {
      const footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isFooterVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      footerObserver.observe(footer);
    }

    // Handle resize events
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateStickyVisibility();
      }, 150);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
